"use client";
import classNames from "classnames";
import { usePathname } from "next/navigation";
import styles from "./layout.module.css";

export function NavLi({ children, to }: React.PropsWithChildren<{ to: string }>) {
  const pathnname = usePathname();
  return (
    <li
      className={classNames(styles.navItem, {
        [styles.navItemActive]: pathnname?.startsWith(to),
      })}>
      {children}
    </li>
  );
}
